import type {} from '@redux-devtools/extension';
import { v4 as uuid } from 'uuid';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { NotificationState } from 'modules/shop/notificationManager/types';

export const useNotificationManager = create(
  devtools<NotificationState>(
    (updateNotificationState, getNotificationState) => ({
      notifications: [],
      pushNotification: (notification) => {
        updateNotificationState({
          notifications: [
            {
              ...notification,
              id: uuid(),
            },
            ...getNotificationState().notifications,
          ],
        });
      },
      clearNotifications: () => {
        updateNotificationState({ notifications: [] });
      },
      removeNotification: (id) => {
        updateNotificationState({
          notifications: getNotificationState().notifications.filter(
            (notification) => notification.id !== id,
          ),
        });
      },
    }),
  ),
);
